import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import classes from './CompareList.module.scss'

/** @type {import("./types").default} */
const CompareList = ({ apps, onAddClick, onRemoveClick }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'compare-basket',
  })

  const { down } = useViewport()
  return (
    <div className={clsx('CompareList', classes.root)}>
      {apps.map(item => (
        <div key={item.id} className={classes.item}>
          <Link
            href={item.cta_urls.detail}
            className={classes.appContainer}
            disableSeo
            {...addEvent({
              engagementDestination: 'go-to_product_details',
              engagementDetails: 'compare-basket_item',
              name: 'engagement_compare_tray',
            })}
          >
            <img src={item.logo_url} alt={`${item.slug}-logo`} className={classes.logo} />
            <Typography variant="heading-xs" className={classes.appName}>
              {item.name}
            </Typography>
          </Link>

          <IconButton
            className={classes.deleteIconButton}
            size={down('sm') ? 'medium' : 'small'}
            onClick={() => onRemoveClick(item)}
            data-testid="compare-basket-remove-button"
            aria-label="Remove product from compare"
            {...addEvent({
              engagementDestination: 'compare-basket_remove-product',
              engagementDetails: 'icon_remove',
              name: 'engagement_compare_tray',
            })}
          >
            <Icon icon={['fas', 'times-circle']} />
          </IconButton>
        </div>
      ))}
      {[...new Array(4 - apps.length)].map((_, index) => (
        <div
          key={`empty-item-${index}`}
          className={classes.emptyItem}
          onClick={onAddClick}
          role="button"
          aria-label="Add product to compare"
          {...(index === 0 && { 'data-testid': 'compare-basket-add-button' })}
          {...addEvent({
            engagementDestination: 'compare-basket_add-product',
            engagementDetails: 'button_add-product',
            name: 'engagement_compare_tray',
          })}
        >
          <Icon icon={['fas', 'times-circle']} className={classes.addIcon} />
        </div>
      ))}
    </div>
  )
}

export default CompareList
